jQuery(document).ready(function(){
  jQuery('.instagram-feed-wrap').each(function (index, value) {
    var $target = jQuery(this).find(".js-instafeed");
    
    instagram.loadContent({
      el: $target,
      clientID: $target.data('client-id'),
      limit: $target.data('count')
    });
  });
  jQuery("a.size_chart_image").fancybox();
  jQuery('#header li.dropdown').hover(
    function () {

      jQuery('#header .full-nav-background').addClass("shown");
    },
    function () {

      jQuery('#header .full-nav-background').removeClass("shown");
    }
  );
  
//   jQuery('#AddressCountry').on('change', function(){
//     var provincesList = jQuery.trim(jQuery(this).find(':selected').data('provinces'));
//     provincesList = provincesList.split('],[');
//     var option = '';
//     jQuery.each(provincesList,function(key,value){
      
//       var province = value.split(',');
      
//       option += '<option value=' + province[0].replace(/[^A-Za-z0-9&]/ig, "") + '>' + province[1].replace(/[^A-Za-z0-9& ]/ig, "") + '</option>';
//     });
//     jQuery('#AddressProvince').html(option);
//   });
});

jQuery(window).on("scroll", function() {
  var c = jQuery(window).scrollTop();
  if(c < 0 && (c = 0), c > 10){
    
    jQuery('#header .background').addClass("shown");
  }else{
    jQuery('#header .background').removeClass("shown");
  }
  
  c <= 0 && (c = 0), c > 10 ? jQuery('.header-logo').addClass("scrolled") : jQuery('.header-logo').removeClass("scrolled"), jQuery('.header-logo').css({
                    
    				
                });
  if(jQuery('#page-hero').length > 0){
    var d = jQuery('#page-hero').offset().top - jQuery(window).scrollTop();
    d <= 0 ? jQuery('#page-hero').css("padding-top", Math.min(323, -1 * d / 3)) : jQuery('#page-hero').css("padding-top", 0);
  }
});
jQuery(document).ready(function(){
	resizeDiv();
//   populatedProvince();
    jQuery('.panel-group').on('hidden.bs.collapse', toggleIcon);
	jQuery('.panel-group').on('shown.bs.collapse', toggleIcon);
    
});

window.onresize = function(event) {
	resizeDiv();
}
function toggleIcon(e) {
    jQuery(e.target)
        .prev('.panel-heading')
        .find(".more-less")
        .toggleClass('fa-angle-down fa-angle-up');
}

function resizeDiv() {
    vpw = jQuery(window).width();
    vph = jQuery(window).height();
    jQuery('#hero').css({'height': vph + 'px','width': vpw + 'px'});
}
// function populatedProvince(){
// 	var provincesList = jQuery.trim(jQuery('#AddressCountry').find(':selected').data('provinces'));
//   if(provincesList){
//     provincesList = provincesList.split('],[');
//     var option = '';
//     jQuery.each(provincesList,function(key,value){
      
//       var province = value.split(',');
      
//       option += '<option value=' + province[0].replace(/[^A-Za-z0-9&]/ig, "") + '>' + province[1].replace(/[^A-Za-z0-9& ]/ig, "") + '</option>';
//     });
//     jQuery('#AddressProvince').html(option);
//   }
// }
(function($) {

	$.fn.dineshSlider = function( options ) {

		// Establish our default settings
		var settings = $.extend({
			slideshow: $(this),
			slides: $(this).find(".slide"),
			bullets: $(this).find(".bullet"),
			counter: $(this).find(".counter"),
			prevControl: $(this).find(".prev.control"),
			nextControl: $(this).find(".next.control"),
			headerContainer: $("#header"),
			navContainer: $("#nav-container"),
			isAnimating: !1,
			autoplayDelay: 10000
		}, options);

		return this.each( function() {
          	
			init($(this));
		});
		function init(c) {
                return  listen(), "hero" === settings.slideshow.attr("id") && hero(), settings.slides.filter(".current").hasClass("dark") ? (settings.navContainer.addClass("light"), settings.headerContainer.addClass("light")) : (settings.navContainer.removeClass("light"), settings.headerContainer.removeClass("light")), settings.slideshow.hasClass("alt-captioned") && settings.slides.each(function() {
                    var b = $(this),
                        c = b.find("img"),
                        d = c.attr("alt");
                    if (d && d.length > 0) {
                        var e = "";
                        e += '<div class="credit">', e += d, e += "</div>", b.append(e)
                    }
                }), window.pauseHeroSlideshow = stopAutoplay, window.resumeHeroSlideshow = startAutoplay, !1
            }
            function hero() {
                settings.titles = settings.slideshow.find(".titles"), settings.titleItems = settings.titles.find(" > div"), settings.titleItems.each(function() {
                    var b = $(this),
                        c = b.innerWidth();
                    b.attr("data-width", c).css({
                        width: c
                    })
                }), settings.titleItems.each(function() {
                    var c = $(this);
                    settings.titles.append(c)
                })
            }
            function listen() {
                settings.bullets[0] && settings.bullets.first().parent().on("click", ".bullet", function() {
                    var c = $(this);
                    c.hasClass("selected") || settings.isAnimating || (stopAutoplay(), goToSlide(c.data("index"), !0))
                }), settings.prevControl[0] && settings.nextControl[0] && (1 === settings.slides.length ? (settings.prevControl.hide(), settings.nextControl.hide()) : (settings.prevControl.on("click", function() {
                    stopAutoplay(), goToPrevSlide()
                }), settings.nextControl.on("click", function() {
                    stopAutoplay(), goToNextSlide()
                }))), settings.slideshow.hasClass("autoplay") && startAutoplay(), settings.slides.each(function() {
                    var b = $(this),
                        c = b.attr("data-url");
                    c && c.length && (b.css("cursor", "pointer"), b.on("click", function(b) {
                        $(b.target).attr("href") || (window.location.href = c)
                    }))
                })
            }
            function startAutoplay() {
                settings.slides.length > 1 && (settings.autoplayInterval = setInterval(function() {
                    goToNextSlide()
                }, settings.autoplayDelay))
            }
            function stopAutoplay() {
                null !== settings.autoplayInterval && (clearInterval(settings.autoplayInterval), settings.autoplayInterval = null)
            }
            function goToSlide(a, c) {
                if (!settings.isAnimating && settings.slides.length > 1) {
                    settings.isAnimating = !0;
                    var d, e, f = settings.slides.filter(".current"),
                        g = settings.slides.eq(parseInt(a));
                    if (settings.bullets[0]) {
                        var d = settings.bullets.filter(".selected"),
                            e = settings.bullets.filter(".bullet[data-index=" + a + "]");
                        d.removeClass("selected"), e.addClass("selected")
                    }
                    if (settings.counter[0] && settings.counter.find(".numerator").text(a + 1), g.hasClass("dark") ? (settings.navContainer.addClass("light"), settings.headerContainer.addClass("light")) : (settings.navContainer.removeClass("light"), settings.headerContainer.removeClass("light")), settings.titleItems && settings.titleItems.length > 0) {
                        var h = settings.titleItems.filter(".bullet[data-index=" + a + "]"),
                            i = h.index();
                        if (0 === i) {
                            var j = settings.titleItems.eq(4),
                                k = settings.titleItems.eq(3);
                            settings.titles.css("text-align", "right"), k.addClass("hidden"), settings.titleItems.eq(2).addClass("left-padded"), settings.titleItems.eq(2).removeClass("left-padded"), settings.titleItems.eq(1).addClass("padding-animation"), setTimeout(function() {
                                settings.titleItems.eq(1).addClass("left-padded"), setTimeout(function() {
                                    settings.titleItems.eq(1).removeClass("left-padded"), setTimeout(function() {
                                        settings.titleItems.eq(1).removeClass("padding-animation")
                                    }, 200)
                                }, 200)
                            }), setTimeout(function() {
                                j.addClass("hidden")
                            }, 100), setTimeout(function() {
                                var a = k.clone(),
                                    c = j.clone();
                                settings.titles.prepend(a), settings.titles.prepend(c), setTimeout(function() {
                                    a.removeClass("hidden"), setTimeout(function() {
                                        c.removeClass("hidden")
                                    }, 300)
                                }, 50), setTimeout(function() {
                                    k.remove(), j.remove(), settings.titleItems = settings.titles.find(" > div"), settings.bullets = settings.slideshow.find(".bullet"), settings.isAnimating = !1
                                }, 500)
                            }, 400)
                        } else if (4 === i) {
                            var j = settings.titleItems.eq(0),
                                k = settings.titleItems.eq(1);
                            settings.titles.css("text-align", "left"), k.addClass("hidden"), settings.titleItems.eq(2).addClass("right-padded"), settings.titleItems.eq(2).removeClass("right-padded"), settings.titleItems.eq(3).addClass("padding-animation"), setTimeout(function() {
                                settings.titleItems.eq(3).addClass("right-padded"), setTimeout(function() {
                                    settings.titleItems.eq(3).removeClass("right-padded"), setTimeout(function() {
                                        settings.titleItems.eq(3).removeClass("padding-animation")
                                    }, 200)
                                }, 200)
                            }), setTimeout(function() {
                                j.addClass("hidden")
                            }, 100), setTimeout(function() {
                                var a = k.clone(),
                                    c = j.clone();
                                settings.titles.append(a), settings.titles.append(c), setTimeout(function() {
                                    a.removeClass("hidden"), setTimeout(function() {
                                        c.removeClass("hidden")
                                    }, 300)
                                }, 50), setTimeout(function() {
                                    k.remove(), j.remove(), settings.titleItems = settings.titles.find(" > div"), settings.bullets = settings.slideshow.find(".bullet"), settings.isAnimating = !1
                                }, 500)
                            }, 400)
                        }
                    }
                    settings.slideshow.hasClass("fading") ? (g.css("z-index", 2).fadeTo(200, 1), setTimeout(function() {
                        f.removeClass("current").css("z-index", 0).fadeTo(0, 0), g.addClass("current").css("z-index", 1), settings.titleItems.length < 1 && (settings.isAnimating = !1)
                    }, 200)) : settings.slideshow.hasClass("sliding") && (c ? g.css("left", "100%") : g.css("left", "-100%"), setTimeout(function() {
                        c ? f.animate({
                            left: "-100%"
                        }, 500) : f.animate({
                            left: "100%"
                        }, 500), g.animate({
                            left: "0"
                        }, 500), settings.bullets[0] && (d.removeClass("selected"), e.addClass("selected")), setTimeout(function() {
                            f.removeClass("current"), g.addClass("current"), settings.isAnimating = !1
                        }, 500)
                    }))
                }
            }
            function goToNextSlide() {
                var a = settings.slides.filter(".current").index();
                a === settings.slides.length - 1 ? goToSlide(0, !0) : goToSlide(a + 1, !0)
            }
            function goToPrevSlide() {
                var a = settings.slides.filter(".current").index();
                0 === a ? goToSlide(settings.slides.length - 1, !1) : goToSlide(a - 1, !1)
            }

	};

}(jQuery));
	// custom initialization
	jQuery(window).load(function() {
		jQuery(".slideshow").dineshSlider();
	});

var instagram = {
  loadContent: function(s){
    if(s.clientID) {
      var url = 'https://api.instagram.com/v1/users/self/media/recent/?access_token='+s.clientID+'&count=1';

      jQuery.ajax({
        type: 'GET',
        url: url,
        dataType: 'jsonp',
        success: function(data) {
          
          if(data.meta.code === 200 && data.data.length) {
            var data = data.data;
            var count = 0;
            s.el.empty();

            for(var i = 0; i < data.length; i++) {
              var thisMedia = data[i], item;

              if(!thisMedia.images.low_resolution.url.includes("null")) {
                item = '<img class="il-photo__img" src="'+thisMedia.images.low_resolution.url+'" data-filter="'+thisMedia.filter+'" />';
                item = '<a href="'+thisMedia.link+'" target="_blank">'+item+'</a>';
                jQuery('.instagram-feed-wrap .js-instafeed').css({'background':'url('+thisMedia.images.low_resolution.url+') center center no-repeat','opacity':'1'});
                jQuery('.instagram_mobile img').attr('src',thisMedia.images.low_resolution.url);
              }

              if(thisMedia.videos) {
                var src;

                if(thisMedia.videos.standard_resolution) {
                  src = thisMedia.videos.standard_resolution.url;
                } else if(thisMedia.videos.low_resolution) {
                  src = thisMedia.videos.low_resolution.url;
                } else if(thisMedia.videos.low_bandwidth) {
                  src = thisMedia.videos.low_bandwidth.url;
                }

                item = '<video poster="'+thisMedia.images.low_resolution.url+'" controls>';
                item += '<source src="'+src+'" type="video/mp4;"></source>';
                item += '</video>';
              }
              if(item) {
                item = '<div class="one-fifth column">'+item+'</div>';
              }
              if(item !== '') {
               // s.el.append(item);
                count++;
              }
              if(count == s.limit) {
                break;
              }
            }
          }
        },
        error: function() {
        }
      });
    }
  }
}
